import React, { useState, useEffect } from 'react'
import { useOrderStore } from 'src/hooks/order';
import { DateRangePicker } from 'rsuite';
import "rsuite/dist/rsuite.min.css";
import useReduxState from 'src/hooks/useReduxState';
import moment from 'moment';
import { startOfDay, endOfDay, subMonths, subDays } from 'date-fns';
import { useAxiosIndicatorCheck } from 'src/store/hook/useAxiosIndicatorCheck';
import Helper from 'src/support/Helper';

const OrderHistoryDateFilter = (props) => {
    const [__check] = useAxiosIndicatorCheck();
    const [{ order_list }, { }] = useOrderStore();

    const [dateRange, setDateRange] = useReduxState('', 'setDateRange');
    const [selectedDateText, setSelectedDateText] = useState('');
    const [dateRangeSelectedPredefined, set_dateRangeSelectedPredefined] = useState('');
    const [dateRangeObject, set_dateRangeObject] = useState([Helper.valueIsNotNull(props?.orderDate) ? new Date(props?.orderDate) : null, Helper.valueIsNotNull(props?.orderDate) ? new Date(props?.orderDate)  : endOfDay(new Date())]);
    useEffect(() => {
        setDateRange(setDateForFilter(dateRangeObject));
        if (props?.orderDate) {
            setSelectedDateText((moment(props?.orderDate).format(Helper.getDatepickerFormat().toUpperCase()) + ' - ' + moment(props?.orderDate).format(Helper.getDatepickerFormat().toUpperCase())));
            set_dateRangeSelectedPredefined('');
        }

    }, [dateRangeObject])

    const setDateForFilter = (dtObj) => {
        let dt1_frm = moment(dtObj[0]).local().format("YYYYMMDD");
        let dt2_frm = moment(dtObj[1]).local().format("YYYYMMDD");
        let _dt = dt1_frm + ';' + dt2_frm;
        return _dt;
    }

    const Ranges = [
        {
            key: 'Day15',
            label: 'Past 15 days',
            slug: 'Past 15 days',
            value: [startOfDay(subDays(new Date(), 14)), endOfDay(new Date())],
            placement: 'left'
        },
        {
            key: 'Day30',
            label: 'Past 30 days',
            slug: 'Past 30 days',
            value: [startOfDay(subDays(new Date(), 29)), endOfDay(new Date())],
            placement: 'left'

        },
        {
            key: 'Month6',
            label: 'Past 6 months',
            slug: 'Past 6 months',
            value: [startOfDay(subMonths(new Date(), 6)), endOfDay(new Date())],
            placement: 'left'
        },
        {
            key: 'Month12',
            label: 'Past 12 months',
            slug: 'Past 12 months',
            value: [startOfDay(subMonths(new Date(), 12)), endOfDay(new Date())],
            placement: 'left'
        },
        {
            key: 'justBottomLabel',
            label: 'Select range by clicking on the dates.',
            value: "",
            placement: 'bottom'
        }
    ];
    return (
        <>
            {!props.firstServerCall && <div className='m-b-20'><div className='filer-by-date d-flex align-items-center m-b-10'>
                <b className='d-inline-block'>Change current date range for new results:</b>

                <a className="text-blue2 order-date-range-filter ms-2" id='order-date-range-filter'>
                    <DateRangePicker
                        style={{ width: '100% !important' }}
                        appearance="subtle"
                        placeholder="Select Range"
                        onChange={(dates, event) => {
                            set_dateRangeObject(dates);
                            $('.rs-picker-daterange-predefined').find('button').removeClass('selected');
                            if(event.target.getAttribute('slug') && event.target.getAttribute('slug') !== null) {
                                setSelectedDateText(event.target.getAttribute('slug'));
                                set_dateRangeSelectedPredefined(event.target.getAttribute('slug'));
                                $('.rs-picker-daterange-predefined').find('button[slug="'+event.target.getAttribute('slug')+'"]').addClass('selected');
                            } else {
                                setSelectedDateText((moment(dates[0]).format(Helper.getDatepickerFormat().toUpperCase()) +' - '+ moment(dates[1]).format(Helper.getDatepickerFormat().toUpperCase())));
                                set_dateRangeSelectedPredefined('');
                            }
                        }}
                        onEnter={()=>{
                            $('.rs-picker-daterange-predefined').find('button').removeClass('selected');
                            if(dateRangeSelectedPredefined && dateRangeSelectedPredefined.trim() != "") {
                                $('.rs-picker-daterange-predefined').find('button[slug="'+dateRangeSelectedPredefined+'"]').addClass('selected');
                            }
                        }}
                        value={dateRangeObject}
                        character=" - "
                        cleanable={false}
                        format={Helper.getDatepickerFormat()}
                        ranges={Ranges}
                        editable={false}
                    />
                </a>
                
            </div>
                <b>{ !__check(['ORDER_API_CALL']).status && order_list.total !== undefined && order_list.total} Results</b> showing:<b> {selectedDateText}</b>
            </div> }
        </>
    )
}

export default OrderHistoryDateFilter